// Export the Component Definition for use in Contentful Studio
export {FAQAccordionContentfulComponentDefinition} from './FAQAccordionContentfulDefinition';
export {default} from './FAQAccordion';
